import React, { useEffect, useRef, useState } from "react";
import { Send, Bot, Loader2, Plus } from "lucide-react";
import { toast } from "sonner";
import client, { apiErr } from "../../lib/api";
import { useAuth } from "../../context/AuthContext";
import { AiText } from "../ui-kit";

const SUGGEST = ["Aaj Gold ka kya view hai?", "Lot size kaise calculate karu?", "Premium signals kaise milenge?", "Aaj koi badi news hai?"];
const newSid = () => `s-${Date.now().toString(36)}`;

export function AIChat() {
  const { user } = useAuth();
  const key = `fx_chat_sid_${user?.id}`;
  const [sid, setSid] = useState(() => localStorage.getItem(key) || newSid());
  const [msgs, setMsgs] = useState([]);
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);
  const end = useRef(null);

  useEffect(() => {
    localStorage.setItem(key, sid);
    client.get("/hub/chat", { params: { session_id: sid } }).then(({ data }) => setMsgs(data)).catch(() => {});
  }, [sid, key]);
  useEffect(() => {
    end.current?.scrollIntoView({ behavior: "smooth" });
  }, [msgs, busy]);

  const send = async (m) => {
    const q = (m || text).trim();
    if (!q || busy) return;
    setText("");
    setMsgs((x) => [...x, { role: "user", text: q, id: Math.random() }]);
    setBusy(true);
    try {
      const { data } = await client.post("/hub/chat", { session_id: sid, message: q });
      setMsgs((x) => [...x, { role: "assistant", text: data.reply, id: Math.random() }]);
    } catch (e) { toast.error(apiErr(e)); } finally { setBusy(false); }
  };

  return (
    <div className="surface flex flex-col h-[70vh] max-w-3xl" data-testid="ai-chat">
      <div className="flex items-center gap-2 px-4 py-3 border-b border-[color:var(--border-subtle)]">
        <div className="w-8 h-8 bg-gold/15 border border-gold/40 flex items-center justify-center"><Bot size={16} className="text-gold" /></div>
        <div><div className="text-sm text-white font-semibold">Fateh AI</div><div className="text-[10px] text-slate-500">Signals, risk, broker aur trading sawaal puchiye</div></div>
        <button data-testid="ai-chat-new" onClick={() => { setMsgs([]); setSid(newSid()); }} className="ml-auto shrink-0 whitespace-nowrap text-xs text-slate-400 hover:text-white flex items-center gap-1"><Plus size={13} />New chat</button>
      </div>
      <div className="flex-1 overflow-y-auto p-4 space-y-3">
        {!msgs.length && (
          <div className="flex flex-wrap gap-2" data-testid="ai-chat-suggestions">
            {SUGGEST.map((s) => <button key={s} onClick={() => send(s)} className="px-3 py-1.5 text-xs border border-[color:var(--border-subtle)] text-slate-300 hover:border-gold hover:text-gold transition-colors duration-200">{s}</button>)}
          </div>
        )}
        {msgs.map((m) => (
          <div key={m.id} className={`flex ${m.role === "user" ? "justify-end" : ""}`}>
            <div className={`max-w-[85%] px-3.5 py-2.5 text-sm ${m.role === "user" ? "bg-gold text-black" : "border border-[color:var(--border-subtle)] bg-white/[0.03]"}`} data-testid={`chat-msg-${m.role}`}>
              {m.role === "user" ? m.text : <AiText text={m.text} />}
            </div>
          </div>
        ))}
        {busy && <div className="text-xs text-slate-500 flex items-center gap-2"><Loader2 size={13} className="animate-spin" />Fateh AI soch raha hai…</div>}
        <div ref={end} />
      </div>
      <div className="p-3 border-t border-[color:var(--border-subtle)] flex gap-2">
        <input data-testid="ai-chat-input" value={text} onChange={(e) => setText(e.target.value)} onKeyDown={(e) => e.key === "Enter" && send()} placeholder="Apna sawaal likhiye…" className="flex-1 bg-transparent border border-[color:var(--border-subtle)] px-3 py-2 text-sm text-white focus:border-gold outline-none" />
        <button data-testid="ai-chat-send" onClick={() => send()} disabled={busy} className="btn-gold px-4"><Send size={15} /></button>
      </div>
    </div>
  );
}
